import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Калъфки за възглавници ранфорс 100% памук | Размери по поръчка | GoToBed',
  description:
    'Калъфки за възглавници от ранфорс 100% памук. Едноцветни и шарени, стандартни и нестандартни размери. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Калъфки за възглавници ранфорс – 100% памук
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Калъфки за възглавници ранфорс от 100% памук
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Калъфките за възглавници от ранфорс са изработени от 100% памук и се предлагат в
          едноцветни и шарени (с принт) десени. Тези памучни калъфки за възглавници се изработват по
          поръчка и се предлагат в разнообразие от размери за различни възглавници, включително
          ортопедични и нестандартни модели. Сред популярните размери са 40/60, 50/70, 60/80 и
          70/90.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyKalufkiRanfors />;
}

function SeoBodyKalufkiRanfors() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Калъфки за възглавници от ранфорс – здрав и дишащ памучен плат */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Калъфки за възглавници от ранфорс – здрав и дишащ памучен плат
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Калъфките за възглавници от 100% памук ранфорс са практичен и удобен избор за ежедневно
        спално бельо, защото се отличават със здравина, добра издръжливост и приятна мекота.
        Ранфорсът е висококачествена памучна материя с класическо тъкане, която е дишаща, комфортна
        и подходяща за всекидневна употреба.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Благодарение на естествените свойства на памука, калъфките от ранфорс са дишащи, комфортни и
        подходящи за използване през всички сезони. Платът запазва добре цветовете си и издържа на
        многократно пране, което го прави предпочитан избор за ежедневно използване.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        В тази категория ще откриете разнообразие от калъфки за възглавници от ранфорс в различни
        цветове и десени – както едноцветни, така и шарени модели. Ако искате да разгледате всички
        модели, можете да посетите:
      </Typography>
      <Box sx={{ mb: 2, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/spalno-belio/kalufki/1/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          калъфки за възглавници
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички платове са сертифицирани по OEKO-TEX Standard 100, което гарантира безопасност на
        текстила и липса на вредни вещества.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Калъфките се изработват по индивидуална поръчка според избраните от клиента параметри и
        могат да бъдат ушити както в стандартни, така и в нестандартни размери.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако желаете да съчетаете калъфките с останалото спално бельо, можете да разгледате и:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          пликове за завивки ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/charshafi/1/1/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи с ластик ранфорс
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Налични размери калъфки за възглавници ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Налични размери калъфки за възглавници ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Калъфките могат да бъдат изработени в следните размери.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Правоъгълни размери
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '50/70',
            '50/75',
            '50/80',
            '53/73',
            '55/75',
            '60/70',
            '60/80',
            '60/90',
            '60/100',
            '40/60',
            '40/50',
            '43/63',
            '48/68',
            '35/53',
            '33/66',
            '37/47',
            '33/43',
            '54/63',
            '54/71',
            '54/74',
            '54/76',
            '54/82',
            '54/99',
            '57/87',
            '57/114',
            '39/99'
          ].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Размери за дълги възглавници
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {['54/145', '54/165', '54/185'].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Квадратни размери
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '82/82',
            '70/70',
            '65/65',
            '60/60',
            '55/55',
            '50/50',
            '45/45',
            '40/40',
            '35/35',
            '30/30 см'
          ].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Ако вашата възглавница е с различен размер, можем да изработим калъфка и по индивидуална
          поръчка, така че да пасне точно на вашата възглавница.
        </Typography>

        {/* H2: Популярни размери калъфки за възглавници ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери калъфки за възглавници ранфорс
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          {[
            'калъфка 50/70 (50х70) см',
            'калъфка 60/80 (60х80) см',
            'калъфка 70/70 (70х70) см',
            'калъфка 40/60 (40х60) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>

        {/* H2: Още продукти от ранфорс за вашата спалня */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Още продукти от ранфорс за вашата спалня
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ако предпочитате практичността и естествения комфорт на ранфорса, можете да комбинирате
          калъфките с други продукти от същата материя. В нашия онлайн магазин ще откриете
          разнообразие от спално бельо от ранфорс, което позволява лесно да съчетаете всички
          елементи на комплекта.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Разгледайте и:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi/1/1/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик ранфорс
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Комбинирането на плик за завивка, чаршаф и калъфки от ранфорс създава практичен и стилен
          комплект спално бельо, който осигурява комфорт по време на сън и е подходящ за ежедневно
          използване.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за калъфки за възглавници ранфорс
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какво представляват калъфките за възглавници от ранфорс?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Калъфките за възглавници от ранфорс са изработени от 100% памучен плат, който се
            отличава с добра издръжливост, дишаемост и приятна мекота. Ранфорсът е една от
            най-предпочитаните материи за ежедневно спално бельо, защото е комфортен за сън и
            издържа на многократно пране.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какви размери калъфки за възглавници ранфорс предлагате?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Предлагаме голямо разнообразие от размери калъфки за възглавници, както стандартни, така
            и нестандартни. Сред най-популярните размери са:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>50/70</li>
            <li>60/80</li>
            <li>60/90</li>
            <li>70/70</li>
            <li>40/60</li>
          </Box>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Освен тях можем да изработим калъфки и в много други размери, за да паснат точно на
            вашата възглавница.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Могат ли калъфките от ранфорс да се изработят по индивидуален размер?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Всички калъфки за възглавници от ранфорс се изработват по индивидуална поръчка. Това
            позволява да изберете точния размер според вашата възглавница, включително когато тя е с
            нестандартни размери.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какви са основните предимства на ранфорса?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Ранфорсът е естествен памучен плат с много добри свойства за спално бельо. Основните му
            предимства са:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>&#10004; 100% естествен памук</li>
            <li>&#10004; добра дишаемост</li>
            <li>&#10004; издръжливост при пране</li>
            <li>&#10004; запазване на цветовете</li>
            <li>&#10004; комфорт през всички сезони</li>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се калъфките от ранфорс при пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички памучни платове, ранфорсът може да има естествена свиваемост около 4–5% при
            пране. Затова при по-пухкави възглавници е добре да се предвиди малко по-голям размер.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са калъфките от ранфорс за ежедневна употреба?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Ранфорсът е много издръжлива памучна материя, която запазва формата и цветовете си
            дори след многократно пране. Това прави калъфките от ранфорс отличен избор за ежедневно
            използване.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Мога ли да комбинирам калъфките от ранфорс с друго спално бельо?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Да. Калъфките могат лесно да се съчетаят с други продукти от същата материя, за да
            създадете хармоничен комплект спално бельо. Можете да разгледате:
          </Typography>
          <Box sx={{ pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              пликове за завивки ранфорс
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/charshafi/1/1/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              чаршафи ранфорс
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              чаршафи с ластик ранфорс
            </Typography>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Каква е разликата между ранфорс и памучен сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            И двете материи са 100% памук, но се различават по начина на тъкане.
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>Ранфорс – плътна и издръжлива материя, подходяща за ежедневно използване.</li>
            <li>
              Памучен сатен – по-фин, по-мек и гладък плат с лек блясък и по-луксозно усещане.
            </li>
          </Box>
          <Box sx={{ mt: 1, pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/kalufki/1/2/1"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              вижте калъфки за възглавници памучен сатен
            </Typography>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват калъфките за възглавници?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички калъфки за възглавници от ранфорс се изработват в България по индивидуална
            поръчка. Това позволява да предложим голямо разнообразие от размери и високо качество на
            изработката.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За колко време се изработват калъфките от ранфорс?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Калъфките се изработват след направена поръчка. Обичайният срок за изработка е между 3 и
            10 работни дни, като в повечето случаи поръчките са готови в рамките на 4–7 работни дни.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
